/* ============================================
   Cookie Consent JS — Mark Ryden Wholesale
   ============================================ */

(function () {
  'use strict';

  var COOKIE_KEY = 'bls_cookie_consent';
  var PRICELIST_KEY = 'bls_pricelist_shown';
  var BULKOFFER_KEY = 'bls_bulkoffer_shown';
  var BULKOFFER_DELAY = 8000; // 8 seconds

  // ---- Helpers ----
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(JSON.stringify(value)) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) {
      try { return JSON.parse(decodeURIComponent(match[2])); } catch (e) { return null; }
    }
    return null;
  }

  function show(el) { if (el) el.style.display = ''; }
  function hide(el) { if (el) el.style.display = 'none'; }

  // ---- Cookie Bar ----
  var cookieBar = document.getElementById('bls-cookie-bar');
  var cookieModal = document.getElementById('bls-cookie-modal');

  function initCookieConsent() {
    var prefs = getCookie(COOKIE_KEY);
    if (!prefs) {
      // First visit: show cookie bar
      show(cookieBar);
    }
  }

  function acceptAll() {
    setCookie(COOKIE_KEY, { necessary: true, analytics: true, marketing: true }, 365);
    hide(cookieBar);
    hide(cookieModal);
  }

  function rejectAll() {
    setCookie(COOKIE_KEY, { necessary: true, analytics: false, marketing: false }, 365);
    hide(cookieBar);
    hide(cookieModal);
  }

  function savePrefs() {
    var analytics = document.getElementById('bls-pref-analytics');
    var marketing = document.getElementById('bls-pref-marketing');
    setCookie(COOKIE_KEY, {
      necessary: true,
      analytics: analytics ? analytics.checked : false,
      marketing: marketing ? marketing.checked : false
    }, 365);
    hide(cookieModal);
    hide(cookieBar);
  }

  function openCookieModal() {
    // Restore saved prefs into toggles
    var prefs = getCookie(COOKIE_KEY);
    if (prefs) {
      var analytics = document.getElementById('bls-pref-analytics');
      var marketing = document.getElementById('bls-pref-marketing');
      if (analytics) analytics.checked = !!prefs.analytics;
      if (marketing) marketing.checked = !!prefs.marketing;
    }
    hide(cookieBar);
    show(cookieModal);
  }

  // Cookie bar buttons
  var btnBarReject = document.getElementById('bls-cookie-bar-reject');
  var btnBarManage = document.getElementById('bls-cookie-bar-manage');
  var btnBarAccept = document.getElementById('bls-cookie-bar-accept');
  if (btnBarReject) btnBarReject.addEventListener('click', rejectAll);
  if (btnBarManage) btnBarManage.addEventListener('click', openCookieModal);
  if (btnBarAccept) btnBarAccept.addEventListener('click', acceptAll);

  // Cookie modal buttons
  var btnModalClose = document.getElementById('bls-cookie-modal-close');
  var btnSave = document.getElementById('bls-cookie-save');
  var btnAcceptAll = document.getElementById('bls-cookie-accept-all');
  if (btnModalClose) btnModalClose.addEventListener('click', function () { hide(cookieModal); show(cookieBar); });
  if (btnSave) btnSave.addEventListener('click', savePrefs);
  if (btnAcceptAll) btnAcceptAll.addEventListener('click', acceptAll);

  // Click outside modal to close
  if (cookieModal) {
    cookieModal.addEventListener('click', function (e) {
      if (e.target === cookieModal) { hide(cookieModal); show(cookieBar); }
    });
  }

  // ---- Price List Popup ----
  var pricelistModal = document.getElementById('bls-pricelist-modal');
  var pricelistClose = document.getElementById('bls-pricelist-close');
  var pricelistForm = document.getElementById('bls-pricelist-form');
  var pricelistSuccess = document.getElementById('bls-pricelist-success');

  // Trigger: any element with data-open="pricelist"
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-open="pricelist"]');
    if (el) { e.preventDefault(); show(pricelistModal); }
  });

  if (pricelistClose) pricelistClose.addEventListener('click', function () { hide(pricelistModal); });
  if (pricelistModal) {
    pricelistModal.addEventListener('click', function (e) {
      if (e.target === pricelistModal) hide(pricelistModal);
    });
  }
  if (pricelistForm) {
    pricelistForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = document.getElementById('pl-email').value;
      var company = document.getElementById('pl-company').value;
      var country = document.getElementById('pl-country').value;
      // POST to Shopify contact form
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'form_type=contact&utf8=%E2%9C%93&contact[email]=' + encodeURIComponent(email) +
              '&contact[body]=Price+List+Request+-+Company:+' + encodeURIComponent(company) +
              '+Country:+' + encodeURIComponent(country)
      });
      hide(pricelistForm);
      show(pricelistSuccess);
      localStorage.setItem(PRICELIST_KEY, '1');
    });
  }

  // ---- Bulk Offer Popup ----
  var bulkofferModal = document.getElementById('bls-bulkoffer-modal');
  var bulkofferClose = document.getElementById('bls-bulkoffer-close');
  var bulkofferForm = document.getElementById('bls-bulkoffer-form');
  var bulkofferSuccess = document.getElementById('bls-bulkoffer-success');

  function showBulkOffer() {
    if (!localStorage.getItem(BULKOFFER_KEY)) {
      show(bulkofferModal);
    }
  }

  // Show bulk offer after delay (not on cart/checkout pages)
  var path = window.location.pathname;
  if (path.indexOf('/cart') === -1 && path.indexOf('/checkout') === -1) {
    setTimeout(showBulkOffer, BULKOFFER_DELAY);
  }

  if (bulkofferClose) {
    bulkofferClose.addEventListener('click', function () {
      hide(bulkofferModal);
      localStorage.setItem(BULKOFFER_KEY, '1');
    });
  }
  if (bulkofferModal) {
    bulkofferModal.addEventListener('click', function (e) {
      if (e.target === bulkofferModal) {
        hide(bulkofferModal);
        localStorage.setItem(BULKOFFER_KEY, '1');
      }
    });
  }
  if (bulkofferForm) {
    bulkofferForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = document.getElementById('bo-email').value;
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'form_type=contact&utf8=%E2%9C%93&contact[email]=' + encodeURIComponent(email) +
              '&contact[body]=10%25+Off+First+Bulk+Order+Claim'
      });
      hide(bulkofferForm);
      show(bulkofferSuccess);
      localStorage.setItem(BULKOFFER_KEY, '1');
    });
  }

  // Trigger: any element with data-open="bulkoffer"
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-open="bulkoffer"]');
    if (el) { e.preventDefault(); show(bulkofferModal); }
  });

  // ---- Init ----
  initCookieConsent();

})();
